<template>
  <div class="neg-pad">
    <div class="billing-header is-hidden-mobile">
      <div class="level header-level">
        <div class="level-left">
          <div class="level-item">
            <h1>Billing</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <tooltip-new :v2="true" iconAlign="middle" :isClickAway="true" hyper-link="https://intercom.help/hellopeter/en/collections/2645584-hellopeter-plans-and-billing">&nbsp;&nbsp;About this feature</tooltip-new>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-paddingless is-marginless billing-section">
      <div class="column is-paddingless equal-height">
        <div v-if="isAvailableForBlackFriday" class="columns is-paddingless">
          <div class="column is-paddingless">
            <a class="is-hidden-mobile" href="/billing/edit-plan/g1/annum"><img alt="Black Friday Discount" class="black-friday-banner-img"
                 src="/static/img/price-increases/price-increase-banner-desktop.png"
              srcset="/static/img/price-increases/price-increase-banner-desktop@2x.png 1.5x,/static/img/price-increases/price-increase-banner-desktop@2x.png 2x, /static/img/price-increases/price-increase-banner-desktop@3x.png 3x"/></a>
            <a class=" is-hidden-desktop" href="/billing/edit-plan/g1/annum"><img alt="Black Friday Discount" class="black-friday-banner-img-mobile"
                 src="/static/img/price-increases/price-increase-banner-mobile.png"
              srcset="/static/img/price-increases/price-increase-banner-mobile@2x.png 1.5x,/static/img/price-increases/price-increase-banner-mobile@2x.png 2x, /static/img/price-increases/price-increase-banner-mobile@3x.png 3x"/></a>
          </div>
        </div>
        <div v-if="isFreeSubscription" class="dummy-msg-warning-">
          <span>!</span><p><strong>Account Suspended</strong> - you no longer have access to your account. <strong>UPGRADE</strong> now to enjoy all our features.</p>
        </div>
        <p class="bs-head">Edit&nbsp;your&nbsp;plan</p>
        <p class="bs-copy has-text-left">Use review invite slider below to edit your plan</p>
        <div class="is-hidden-mobile plan-highlights columns is-paddingless is-marginless">
          <div :class="['column', { 'is-active' : isGrowthMonthly }]">
            <p><span class="discount">&nbsp;</span><br/>GROWTH - <span>Monthly</span></p>
          </div>
          <div :class="['column', { 'is-active' : isGrowthAnnual }]">
            <p><span class="discount" v-html="getGrowthDiscountPercent"></span><br/>GROWTH - <span>Annual</span></p>
          </div>
          <div :class="['column', { 'is-active' : isPremium }]">
            <p><span class="discount">&nbsp;</span><br/>PREMIUM - <span>Annual</span></p>
          </div>
        </div>
        <custom-slider :black-friday="isAvailableForBlackFriday" :default-value="defaultSliderValue"
                       :labels="sliderLabels" v-on:custom-slider-updated="changeSlider"></custom-slider>
        <div class="columns card-columns is-paddingless is-hidden-mobile">
          <div class="column is-paddingless">
            <div :class="['card', { 'is-active' : isGrowthAnnual || isGrowthMonthly }]">
              <h3 class="header">GROWTH</h3>
              <p>GROWTH includes:</p>
              <ul>
                <li>Customisable email invite templates</li>
                <li>SMS review invites</li>
                <li>Photo reviews</li>
                <li>Google review collection</li>
                <li>Google review monitoring &amp; management</li>
                <li>Facebook review tab</li>
                <li>Social Ads</li>
                <li>Customisable on-site widget library</li>
                <li>Full review &amp; invite performance analytics</li>
                <li>Google &amp; Net Promoter Score analytics</li>
              </ul>
              <!-- <div class="see-features"> -->
              <!--   <p class="has-text-centered"><a href="#" @click.prevent="showFeaturesModal">SEE ALL FEATURES</a></p> -->
              <!-- </div> -->
            </div>
          </div>
          <div class="column is-paddingless">
            <div :class="['card', { 'is-active' : isPremium }]">
              <h3 class="header">PREMIUM</h3>
              <p>All the greatness of GROWTH, and:</p>
              <ul>
                <li>Multi-location review collection</li>
                <li>Advanced review management</li>
                <li>Advanced notifications</li>
                <li>Competitor analysis</li>
                <li>Advanced Google search insights</li>
                <li>Multi-user logins</li>
                <li>Full API access with support</li>
                <li class="hide">&nbsp;</li>
                <li class="hide">&nbsp;</li>
                <li class="hide">&nbsp;</li>
              </ul>
              <!-- <div class="see-features"> -->
              <!--   <p class="has-text-centered"><a href="#" @click.prevent="showFeaturesModal">SEE ALL FEATURES</a></p> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
      <summary-section :checkout-url="checkoutUrl" :cycle="frequency"
                       :is-onboard="isOnboard"
                       :disable-checkout="isSliderEqualDefault" :is-billing-section="isBillingSection"
                       :is-billing-edit-section="isBillingSection"
                       :is-checkout-publishing="isCheckoutPublishing"
                       :name="tier" :show-checkout="showCheckout"
                       :is-currently-free="isCurrentlyFree"
                       :qualifies-for-black-friday-discount="isSelectedPlanAvailableForBlackFridayDiscount"
                       :want-to-know-more="showWantToKnowMore"></summary-section>
      <div :class="['modal', { 'is-active' : featuresModalShow }]">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title has-text-centered">&nbsp;</p>
            <button aria-label="close" class="delete" @click="closeFeaturesModal"></button>
          </header>
          <section class="modal-card-body">
            <table class="table">
              <thead>
              <tr>
                <td>&nbsp;</td>
                <td>FREE</td>
                <td>GROWTH</td>
                <td>PREMIUM</td>
              </tr>
              </thead>
              <tbody>
              <tr class="row-heading">
                <td colspan="4">Collect&nbsp;reviews&nbsp;to&nbsp;build&nbsp;your&nbsp;reputation</td>
              </tr>
              <tr>
                <td>Review&nbsp;invites</td>
                <td class="override">20/month</td>
                <td class="override">Starts&nbsp;at&nbsp;50/month</td>
                <td class="override">Starts&nbsp;at&nbsp;6000/year</td>
              </tr>
              <tr>
                <td>Review&nbsp;share&nbsp;link</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Landing&nbsp;page&nbsp;email&nbsp;review&nbsp;invites</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>In-mail&nbsp;review&nbsp;invites</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>SMS&nbsp;review&nbsp;invites&nbsp;and&nbsp;customisation</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>In-store&nbsp;review&nbsp;collection</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Multiple&nbsp;location&nbsp;in-store&nbsp;review&nbsp;collection</td>
                <td>&nbsp;</td>
                <td class="override">Limited</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>On-site&nbsp;review&nbsp;collection&nbsp;widget&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Google&nbsp;review&nbsp;collection</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Facebook&nbsp;review&nbsp;collection&nbsp;widget&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Invoice&nbsp;based&nbsp;review&nbsp;collection</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Email&nbsp;review&nbsp;collection</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Photo&nbsp;review&nbsp;collection&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Email&nbsp;invitation&nbsp;template&nbsp;branding&nbsp;and&nbsp;customisation</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>One&nbsp;click&nbsp;invitation&nbsp;resends</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr class="row-heading">
                <td colspan="4">Showcase&nbsp;your&nbsp;reviews&nbsp;to&nbsp;build&nbsp;social&nbsp;proof&nbsp;and&nbsp;attract&nbsp;customers</td>
              </tr>
              <tr>
                <td>One&nbsp;click&nbsp;social&nbsp;sharing</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>On-site&nbsp;trust&nbsp;badges</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>On-site&nbsp;review&nbsp;widget&nbsp;library&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>On-site&nbsp;dedicated&nbsp;SEO&nbsp;review&nbsp;page</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Social&nbsp;ads</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Facebook&nbsp;review&nbsp;tab</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Widget&nbsp;customisation</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>


              <tr class="row-heading">
                <td colspan="4">Get&nbsp;found&nbsp;easily&nbsp;and&nbsp;drive&nbsp;traffic</td>
              </tr>
              <tr>
                <td>Hellopeter&nbsp;business&nbsp;profile&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Get&nbsp;listed&nbsp;as&nbsp;a&nbsp;verified&nbsp;business</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Google&nbsp;rich&nbsp;snippets&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Google&nbsp;SEO</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Improve&nbsp;Google&nbsp;keyword&nbsp;reach&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>


              <tr class="row-heading">
                <td colspan="4">Manage&nbsp;reviews&nbsp;and&nbsp;engage&nbsp;with&nbsp;your&nbsp;customers</td>
              </tr>
              <tr>
                <td class="cell-heading">Replying&nbsp;to&nbsp;reviews</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Reply&nbsp;credits</td>
                <td class="override">3/month</td>
                <td class="override">Starts&nbsp;at&nbsp;5/month</td>
                <td class="override">Starts&nbsp;at&nbsp;500/year</td>
              </tr>
              <tr>
                <td>Character&nbsp;limit&nbsp;on&nbsp;replies</td>
                <td class="override">300&nbsp;characters</td>
                <td class="override">Unlimited</td>
                <td class="override">Unlimited</td>
              </tr>
              <tr>
                <td>Review&nbsp;credits</td>
                <td class="override">0</td>
                <td class="override">Starts&nbsp;at&nbsp;5/month</td>
                <td class="override">Starts&nbsp;at&nbsp;500/year</td>
              </tr>
              <tr>
                <td>Private&nbsp;replies</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Saved&nbsp;replies</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Purchase&nbsp;add-on&nbsp;review&nbsp;credits</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Purchase&nbsp;add-on&nbsp;review&nbsp;invites</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td class="cell-heading">Notifications</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Email&nbsp;notifications</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>SMS&nbsp;notifications</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Advanced&nbsp;notifications</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td class="cell-heading">Review&nbsp;management</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Google&nbsp;review&nbsp;monitoring&nbsp;&&nbsp;management</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Report&nbsp;reviews</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Team&nbsp;notes</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td class="cell-heading">Profile&nbsp;management</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Users&nbsp;per&nbsp;business&nbsp;profile</td>
                <td class="override">1</td>
                <td class="override">Starts&nbsp;at&nbsp;2</td>
                <td class="override">Starts&nbsp;at&nbsp;8</td>
              </tr>
              <tr>
                <td>Manage&nbsp;multiple&nbsp;business&nbsp;profiles&nbsp;from&nbsp;one&nbsp;account</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>


              <tr class="row-heading">
                <td colspan="4">Measure&nbsp;and&nbsp;Learn&nbsp;</td>
              </tr>
              <tr>
                <td class="cell-heading">Hellopeter&nbsp;analytics</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Dashboard</td>
                <td class="override">Limited&nbsp;to&nbsp;30&nbsp;days</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Review&nbsp;invite&nbsp;performance</td>
                <td class="override">Limited&nbsp;to&nbsp;30&nbsp;days</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Review,&nbsp;TrustIndex&nbsp;&&nbsp;Industry&nbsp;analytics</td>
                <td class="override">Limited&nbsp;to&nbsp;30&nbsp;days</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>NPS&nbsp;analytics</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Competitor&nbsp;analytics</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td class="cell-heading">Google&nbsp;analytics</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Profile&nbsp;views&nbsp;from&nbsp;Google&nbsp;search</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Clicks&nbsp;on&nbsp;your&nbsp;profile&nbsp;from&nbsp;Google</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Average&nbsp;position&nbsp;ranking&nbsp;of&nbsp;your&nbsp;profile&nbsp;&&nbsp;reviews&nbsp;in&nbsp;Google</td>
                <td>&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Search&nbsp;terms&nbsp;used&nbsp;in&nbsp;Google&nbsp;to&nbsp;find&nbsp;your&nbsp;profile</td>
                <td>&nbsp;</td>
                <td class="override">Limited&nbsp;to&nbsp;3</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Most&nbsp;viewed&nbsp;pages&nbsp;in&nbsp;Google&nbsp;for&nbsp;your&nbsp;profile&nbsp;and&nbsp;reviews&nbsp;</td>
                <td>&nbsp;</td>
                <td class="override">Limited&nbsp;to&nbsp;3</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Geographical&nbsp;location&nbsp;of&nbsp;traffic&nbsp;to&nbsp;your&nbsp;profile</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Demographic&nbsp;insights</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Channel&nbsp;insights</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>✓</td>
              </tr>

              <tr class="row-heading">
                <td colspan="4">Priority&nbsp;services</td>
              </tr>
              <tr>
                <td>Email&nbsp;support&nbsp;</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Live&nbsp;chat&nbsp;support</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Customer&nbsp;success</td>
                <td>✓</td>
                <td>✓</td>
                <td>✓</td>
              </tr>


              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable camelcase,indent,no-new,no-undef */
import axios from 'axios'
import TooltipNew from '../../../widgets/TooltipNew'
import SummarySection from './../../../components/Summary'
import CustomSlider from './../../../components/InputSlider'
import Plans from './../../../mixins/plans.js'
import {misc} from '@/mixins'
import moment from 'moment'

export default {
  name: 'BillingEditPlan',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Edit Plan'
  },
  props: {
    currentTier: {
      type: String,
      default: 'g1'
    },
    cycle: {
      type: String,
      default: 'annual'
    }
  },
  components: {
    TooltipNew,
    SummarySection,
    CustomSlider
  },
  mixins: [Plans, misc],
  data () {
    return {
      selectedPlanId: 0,
      isOnboard: false,
      isClickAway: true,
      featuresModalShow: false,
      isCheckoutPublishing: false,
      billingDetails: undefined,
      checkoutUrl: '',
      showWantToKnowMore: false,
      showCheckout: true,
      frequency: 'ANNUAL',
      tier: 'g1',
      defaultSliderValue: '150',
      tooltipQuestion: true,
      isBillingSection: true,
      selectedValue: 30,
      sliderLabels: [
        {
          id: 6,
          name: 'g1',
          label: '50',
          frequency: 'month',
          reviews: 5,
          replies: 5,
          value: 50
        },
        {
          id: 7,
          name: 'g2',
          label: '100',
          frequency: 'month',
          reviews: 10,
          replies: 10,
          value: 100
        },
        {
          id: 8,
          name: 'g3',
          label: '150',
          frequency: 'month',
          reviews: 17,
          replies: 17,
          value: 150
        },
        {
          id: 9,
          name: 'g4',
          label: '250',
          frequency: 'month',
          reviews: 30,
          replies: 30,
          value: 250
        },
        {
          id: 10,
          name: 'g1',
          label: '600',
          frequency: 'annum',
          reviews: 60,
          replies: 60,
          value: 600
        },
        {
          id: 11,
          name: 'g2',
          label: '1200',
          frequency: 'annum',
          reviews: 120,
          replies: 120,
          value: 1200
        },
        {
          id: 12,
          name: 'g3',
          label: '1800',
          frequency: 'annum',
          reviews: 204,
          replies: 204,
          value: 1800
        },
        {
          id: 13,
          name: 'g4',
          label: '3000',
          frequency: 'annum',
          reviews: 360,
          replies: 360,
          value: 3000
        },
        {
          id: 14,
          name: 'p1',
          label: '6000',
          frequency: 'annum',
          reviews: 600,
          replies: 600,
          value: 6000
        },
        {
          id: 15,
          name: 'p2',
          label: '12000',
          frequency: 'annum',
          reviews: 900,
          replies: 900,
          value: 12000
        },
        {
          id: 16,
          name: 'p3',
          label: '18000',
          frequency: 'annum',
          reviews: 1250,
          replies: 1250,
          value: 18000
        },
        {
          id: 17,
          name: 'p4',
          label: 'unlimited',
          frequency: 'annum',
          reviews: 'unlimited',
          replies: 'unlimited',
          value: 'unlimited'
        }
      ],
      sliderLabelsBlackFriday: [
        {
          id: 6,
          name: 'g1',
          label: '50',
          frequency: 'month',
          reviews: 5,
          replies: 5,
          value: 50
        },
        {
          id: 7,
          name: 'g2',
          label: '100',
          frequency: 'month',
          reviews: 10,
          replies: 10,
          value: 100
        },
        {
          id: 8,
          name: 'g3',
          label: '150',
          frequency: 'month',
          reviews: 17,
          replies: 17,
          value: 150
        },
        {
          id: 9,
          name: 'g4',
          label: '250',
          frequency: 'month',
          reviews: 30,
          replies: 30,
          value: 250
        },
        {
          id: 10,
          name: 'g1',
          label: '600',
          frequency: 'annum',
          reviews: 60,
          replies: 60,
          value: 600
        },
        {
          id: 11,
          name: 'g2',
          label: '1200',
          frequency: 'annum',
          reviews: 120,
          replies: 120,
          value: 1200
        },
        {
          id: 12,
          name: 'g3',
          label: '1800',
          frequency: 'annum',
          reviews: 204,
          replies: 204,
          value: 1800
        },
        {
          id: 13,
          name: 'g4',
          label: '3000',
          frequency: 'annum',
          reviews: 360,
          replies: 360,
          value: 3000
        },
        {
          id: 14,
          name: 'p1',
          label: '6000',
          frequency: 'annum',
          reviews: 600,
          replies: 600,
          value: 6000
        },
        {
          id: 15,
          name: 'p2',
          label: '12000',
          frequency: 'annum',
          reviews: 900,
          replies: 900,
          value: 12000
        },
        {
          id: 16,
          name: 'p3',
          label: '18000',
          frequency: 'annum',
          reviews: 1250,
          replies: 1250,
          value: 18000
        },
        {
          id: 17,
          name: 'p4',
          label: 'unlimited',
          frequency: 'annum',
          reviews: 'unlimited',
          replies: 'unlimited',
          value: 'unlimited'
        }
      ],
      today: moment()
    }
  },
  mounted () {
    const dummyInvoice = '585f69e0-258f-11eb-b5c7-23af47804317'
    this.checkoutUrl = `/billing/checkout/${dummyInvoice}`
    if (this.isAvailableForBlackFriday) {
      for (let i = 0; i < this.sliderLabels.length; i++) {
        if (this.getSubscriptionTypeId < this.sliderLabels[i].id || this.getSubscriptionTypeId === 18) {
          this.sliderLabels[i] = this.sliderLabelsBlackFriday[i]
        }
      }
      if (!this.isAnnualSubscription) {
        this.selectedValue = this.blackFridayPlans.annual['g1'].reviewInvites
        this.defaultSliderValue = this.selectedValue.toString()
      } else {
        for (let i = 0; i < this.sliderLabels.length; i++) {
          if (this.getSubscriptionTypeId === this.sliderLabels[i].id) {
            if (typeof this.sliderLabels[i + 1] !== 'undefined') {
              this.selectedValue = this.sliderLabels[i + 1].value
            } else {
              this.selectedValue = this.sliderLabels[i].value
            }
            this.defaultSliderValue = this.selectedValue.toString()
          }
        }
      }
    } else {
      if (this.cycle === 'monthly') {
        Object.entries(this.plans.monthly).forEach((key, _) => {
          if (this.currentTier === key[0]) {
            this.selectedValue = key[1].reviewInvites
          }
        })
      } else {
        Object.entries(this.plans.annual).forEach((key, _) => {
          if (this.currentTier === key[0]) {
            this.selectedValue = key[1].reviewInvites
          }
        })
      }
      this.defaultSliderValue = this.selectedValue.toString()
    }
    this.getBillingAndSubscriptionDetails()
    window.events.$on('checkoutUpgrade', this.createInvoice)
    window.events.$emit('loadHeaderStats')
  },
  destroyed () {
    window.events.$off('checkoutUpgrade')
  },
  methods: {
    closeFeaturesModal () {
      this.featuresModalShow = false
    },
    showFeaturesModal () {
      this.featuresModalShow = true
    },
    createInvoice () {
      this.isCheckoutPublishing = true
      const business_id = localStorage.getItem('org_id')
      let business_reg_number = ''
      if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.billing_details.registration_number !== 'undefined') {
        business_reg_number = this.billingDetails.billing_details.registration_number
      }
      let business_reg_name = localStorage.getItem('org_name')
      if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.billing_details.registered_name !== 'undefined') {
        business_reg_number = this.billingDetails.billing_details.registered_name
      }
      const payment_freq = this.isGrowthMonthly ? 'MONTHLY' : 'ANNUAL'
      let payment_method = 'EFT'
      if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.payment_plan.payment_method !== 'undefined' && this.billingDetails.payment_plan.payment_method !== null && this.billingDetails.payment_plan.payment_method !== '') {
        payment_method = this.billingDetails.payment_plan.payment_method
      }
      const selected_package = this.tier
      let address = ''
      if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.billing_details.billing_address !== 'undefined' && this.billingDetails.billing_details.billing_address !== null && this.billingDetails.billing_details.billing_address !== '') {
        address = this.billingDetails.billing_details.billing_address
      }
      let business_vat_number = ''
      if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.billing_details.vat_number !== 'undefined') {
        business_vat_number = this.billingDetails.billing_details.vat_number
      }
      const select_pro_rata_and_next_month = false
      const org_lat = ''
      const org_lng = ''
      axios.post(`/subscriptions/upgrade-or-renew`, {
        business_id,
        business_reg_number,
        business_reg_name,
        payment_freq,
        payment_method,
        selected_package,
        address,
        select_pro_rata_and_next_month,
        org_lat,
        org_lng,
        business_vat_number
      }).then(({data}) => {
        this.isCheckoutPublishing = false
        this.$router.push(`/billing/checkout/${data.invoice.id}`)
        }).catch((err) => {
          console.log('err', err)
        })
    },
    getBillingAndSubscriptionDetails () {
      const businessSlug = localStorage.getItem('org_slug')
      axios.get(`/${businessSlug}/billing-details`)
        .then(({data}) => {
          this.billingDetails = data
          localStorage.setItem('billingDetails', JSON.stringify(data))
        })
        .catch((err) => {
          console.log('err', err.response.data)
        })
    },
    changeSlider (e) {
      this.selectedValue = parseInt(e.value.label)
      this.tier = e.value.name
      this.selectedPlanId = e.value.id
    }
  },
  computed: {
    isSelectedPlanAvailableForBlackFridayDiscount () {
      const campaignEnd = moment('2025-04-30')
      const isBlackFriday = !this.today.isAfter(campaignEnd)
      if (!isBlackFriday) {
        return false
      }
      const currentSubTypeId = this.getSubscriptionTypeId
      if (currentSubTypeId === 18 || currentSubTypeId === 1) {
        return true
      }
      if (currentSubTypeId === 17) {
        return false
      }

      if (isNaN(this.selectedValue)) {
        return false
      }
      // below condition include check that plan name must be higher i.e g1 monthly => g2 annual or higher. G2 monthly to G3 annual or higher, g3 monthly to g4 annual or higher, g4 monthly to p1 or higher
      const growthIds = [6, 7, 8, 9]
      const growthAnnual = [10, 11, 12, 13]
      return growthIds.includes(currentSubTypeId) && growthAnnual.includes(this.selectedPlanId)
      // const isGreaterPlan = (current, selected) => {
      //   if (growthIds.includes(current)) {
      //     return (selected - current) > 4
      //   }
      //   return selected > current
      // }
      // // return this.selectedValue > subValue || isNaN(this.selectedValue)
      // return isGreaterPlan(currentSubTypeId, this.selectedPlanId)
    },
    currentPlanReviewInvites () {
      const billingDetails = JSON.parse(localStorage.billingDetails)
      const currentPlanCycle = billingDetails.subscription.cycle === 'annum' ? 'annual' : 'monthly'
      if (billingDetails.subscription.name.toLowerCase() === '14 day trial') {
        return this.plans['monthly']['g1'].reviewInvites
      }
      return this.plans[currentPlanCycle][billingDetails.subscription.name.toLowerCase()].reviewInvites
    },
    isGrowthMonthly () {
      // 1000, 4000, 8000
      // const campaignEnd = moment('2025-04-30')
      // const isBlackFriday = !this.today.isAfter(campaignEnd)
      // const threshold = isBlackFriday ? 1000 : 600
      // return this.selectedValue < threshold
      return this.selectedPlanId < 10
    },
    isGrowthAnnual () {
      // const campaignEnd = moment('2025-04-30')
      // const isBlackFriday = !this.today.isAfter(campaignEnd)
      // const threshold = isBlackFriday ? 8000 : 6000
      // return this.selectedValue < threshold && this.selectedValue > 250
      return this.selectedPlanId > 9 && this.selectedPlanId < 14
    },
    isPremium () {
      // const campaignEnd = moment('2025-04-30')
      // const isBlackFriday = !this.today.isAfter(campaignEnd)
      // const threshold = isBlackFriday ? 4000 : 3000
      // return this.selectedValue > threshold || isNaN(this.selectedValue)
      return isNaN(this.selectedValue) || (this.selectedPlanId > 13 && this.selectedPlanId < 18)
    },
    isSliderEqualDefault () {
      return this.currentPlanReviewInvites === this.selectedValue
    },
    isAvailableForBlackFriday () {
      const today = moment()
      const campaignEnd = moment('2025-04-30')
      return !today.isAfter(campaignEnd) && (this.isFreeSubscription || this.isFreeTrial || (this.isGrowthSubscription && !this.isAnnualSubscription))
      // const campaignEnd = moment('2024-11-30')
      // if (this.today.isAfter(campaignEnd)) {
      //   return false
      // }
      // return true
      // if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.subscription !== 'undefined') {
      //   return this.billingDetails.subscription.subscriptionTypeId < 12
      // }
      // return false
    },
    isCurrentlyFree () {
      if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.subscription !== 'undefined') {
        return this.billingDetails.subscription.subscriptionTypeId === 1
      }
      return false
    },
    getGrowthDiscountPercent () {
      // let isCurrentlyFree = false
      //
      // if (typeof this.billingDetails !== 'undefined' && typeof this.billingDetails.subscription !== 'undefined') {
      //   isCurrentlyFree = this.billingDetails.subscription.subscriptionTypeId === 1
      // }
      //
      const campaignEnd = moment('2025-04-30')
      const isAvailableForFree = !this.today.isAfter(campaignEnd)
      if (isAvailableForFree) {
        return ''
      }

      // if (isCurrentlyFree && isAvailableForFree) {
      //   return `Save&nbsp;30&percnt;`
      // }
      // return `<span class="discount">Save&nbsp;10&percnt;</span><br/>GROWTH - <span>Annual</span>`
      return `Save&nbsp;10&percnt;`
    }
  },
  watch: {
    selectedValue (val) {
      this.frequency = 'ANNUAL'
      if (isNaN(val)) {
        this.tier = 'p4'
      } else {
        if (val < 600) {
          this.frequency = 'MONTHLY'
          Object.entries(this.plans.monthly).forEach((key, _) => {
            if (val === key[1].reviewInvites) {
              this.tier = key[0]
            }
          })
        } else {
          Object.entries(this.plans.annual).forEach((key, _) => {
            if (val === key[1].reviewInvites) {
              this.tier = key[0]
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.bs-copy {
  margin-top: 5px;
  margin-bottom: 40px;
}

.neg-pad {
  margin-top: -2.25rem;
  margin-left: -20px;
  margin-right: -20px;
}

.billing-header {
  margin-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 0;
  border-bottom: solid 1px #dbdbdb;
}

.billing-section {
  margin-left: 16px;
  margin-right: 38px;
  padding: 20px 25px 20px 0;
  border-bottom: solid 1px #dbdbdb;
}

.billing-section > .equal-height {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/*.billing-section > .equal-height {*/
/*  margin-top: auto;*/
/*}*/

.billing-section:last-child {
  border: none;
}

.billing-section .bs-head {
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: color("blue-dark");
}

.bs-link, .bs-link:hover, .bs-link:visited {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: right;
  text-decoration: underline;
  color: color("blue");
}

.billing-section p {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  color: #707070;
}

h1 {
  width: 54px;
  height: 22px;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.about {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

/*.level:not(:last-child) {*/
/*  margin-bottom: 0;*/
/*}*/

.level {
  margin-bottom: 5px;
}

.level:first-child {
  margin-bottom: 13px;
}

.input_credits {
  width: 60px;
  height: 35px;
  border: solid 1px rgba(88, 89, 91, 0.32);
  background-color: #ffffff;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.billing-section > .level.has-input:not(:last-child) {
  margin-bottom: 11px;
}

.billing-section > .level.has-input > .level-right > .level-item:last-child > p {
  width: 75px;
}

.level-left .level-item:not(:last-child), .level-right .level-item:not(:last-child) {
  margin-right: 8px;
}

.table > thead > tr > td {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.table > tbody > tr > td {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.table > tbody > tr > td {
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: color("blue");
}

.table > tbody > tr > td:first-child {
  border: none !important;
  font-family: 'Open Sans' !important;
  font-size: 14px !important;
  line-height: 45px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  text-align: left !important;
  color: #707070 !important;
}

.table > tbody > tr > td.override {
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #707070;
}

.table > tbody > tr.row-heading > td {
  font-weight: bold !important;
}

.table > tbody > tr {
  background-color: #ffffff !important;
  height: 48px;
  border-bottom: solid 1px rgba(88, 89, 91, 0.32) !important;
  /*margin-bottom: 10px;*/
}

.table .tr {
  border-bottom: solid 1px rgba(88, 89, 91, 0.32) !important;
}

.table > tbody > tr.row-heading {
  background-color: #f4f4f4 !important;
}

.table > thead > tr > td {
  font-family: 'Open Sans' !important;
  font-size: 18px !important;
  font-weight: bold !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.33 !important;
  letter-spacing: normal !important;
  text-align: center !important;
  color: color("blue-dark") !important;
}

.table > thead {
  position: sticky;
  top: 0;
}

.row-heading {
  font-weight: bold !important;
}

.table td {
  border-bottom: solid 1px rgba(88, 89, 91, 0.32) !important;
}

.table > tbody > tr > td.cell-heading {
  /*background-color: #f4f4f4!important;*/
  font-weight: bold !important;
}

.table {
  width: 100% !important;
}

/**
 * MODAL
 */

.modal-content, .modal-card {
  width: 1149px;
  height: auto;
  max-width: 1149px;
  max-height: 90%;
}

.modal-card-body {
  padding: 0 25px 35px 25px;
  overflow: scroll; /* This is to ensure the dropdown menu is not cut off */
}

.modal-card-head {
  border-bottom: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 20px 25px 16px 25px;
}

.modal-card-foot {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top: none;

  padding: 0 25px 41px 25px;
}

.modal-card-head, .modal-card-foot {
  background-color: #ffffff;
}

.modal-card-title {
  font-family: 'Open Sans' !important;
  font-size: 14px !important;
  font-weight: bold !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.36 !important;
  letter-spacing: normal !important;
  color: color("blue-dark") !important;
}

.modal input[type="text"] {
  width: 341px;
  height: 35px;
  border: solid 1px #dbdbdb;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  padding-left: 15px;
  /*padding-left:18px;*/
}

.modal .delete, .modal .modal-close {
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: #ffffff;
  border: none;
  border-radius: 0;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 30px;
  max-height: 30px;
  max-width: 30px;
  min-height: 30px;
  min-width: 30px;
  outline: 0;
  position: relative;
  vertical-align: top;
  width: 30px;
  padding-right: 0;
  padding-left: 0;
}

.modal .delete::before, .modal .modal-close::before {
  height: 2px;
  width: 20px;
}

.modal .delete::after, .modal .modal-close::after {
  height: 20px;
  width: 2px;
}

.modal .delete::after, .modal .delete::before, .modal .modal-close::after, .modal .modal-close::before {
  background-color: #58595b;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

.mar-top-10 {
  margin-top: 10px;
}

.cc_field {
  width: 103px !important;
}

.cc_info {
  margin-right: 0 !important;
}

.modal .label {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.modal .label:not(:last-child) {
  margin-bottom: 5px;
}

.modal .field.is-grouped > .control:not(:last-child) {
  margin-right: 15px;
}

.modal .button {
  width: 130px;
  height: 35px;
  border-radius: 2px !important;
  background-color: color("blue-dark");
  color: #ffffff;
}

.modal .field.is-grouped.is-grouped-multiline > .control:last-child, .modal .field.is-grouped.is-grouped-multiline > .control:not(:last-child) {
  margin-bottom: 15px;
}

.modal .rel-pos {
  right: 25px;
  top: 8px;
}

.modal .level {
  height: 35px;
  width: 341px;
  padding-left: 140px;
}

/**
 * END MODAL
 */


.billing-section > .column:first-child {
  padding: 20px 16px !important;
}

.plan-highlights {
  max-width: 828px;
}

.plan-highlights > .column.is-active > p {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: bold;
  color: color("blue");
  opacity: 1.0;
}

.plan-highlights > .column.is-active > p > span {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.plan-highlights > .column > p {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: bold;
  color: #58595b;
  opacity: 0.4;
}

.plan-highlights > .column > p > span {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  /*opacity: 0.4;*/
}

.plan-highlights > .column:first-child {
  padding-left: 0;
}

.plan-highlights > .column {
  border-right: 1px dashed rgba(88, 89, 91, 0.32);
  height: 100px;
  padding-top: 0;
}

.plan-highlights > .column:last-child {
  border: none;
  padding-right: 0;
}

.plan-highlights + .control {
  margin-top: -45px;
}

.discount {
  font-family: 'Open Sans';
  font-size: 11px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #17bd85 !important;
}

.card-columns {
  margin-top: 121px;
}

.card-columns > .column {
  max-width: 300px;
  width: 300px;
}

.card-columns > .column:first-child {
  margin-right: 30px;
}

.card-columns > .column > .card {
  border-radius: 5px;
  box-shadow: none;
  border: solid 1px rgba(88, 89, 91, 0.32);
  padding: 20px 5px 20px 25px;
}

.card-columns > .column > .card.is-active {
  border: solid 2px color("blue-dark");
  box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.16);
}

.card > .header {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: color("blue");
  margin-bottom: 17px;
}

.card > p {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  margin-bottom: 15px;
}

.card > ul > li {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.08;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.card > ul > li:before {
  content: '✓';
  padding-right: 4px;
  color: color("blue");
}

.card > ul > li.hide:before {
  content: '';
}

.see-features {
  display: block;
  width: 80%;
  margin: 25px 0 0 10px;
  padding-top: 14px;
  border-top: solid 1px rgba(88, 89, 91, 0.32);
}

.see-features > p > a, .see-features > p > a:hover, .see-features > p > a:visited {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: color("blue");
  text-decoration: underline;
}

@media screen and (max-width: 767px) {
  .neg-pad {
    margin-top: 0rem;
    margin-left: 20px;
    margin-right: 20px;
  }
}

.dummy-msg-warning- {
 height: 40px;
 width: 100%;
 border: 1px solid #e4862c;
 color: #e4862c;
 background-color: #FEF9F4;
 display: flex;
 margin-bottom: 25px;
 flex-direction: row;
 align-items: center;
}

.dummy-msg-warning- strong {
 color: #e4862c;
}

.dummy-msg-warning- {
 padding: 0px 0px;
}
.dummy-msg-warning- span {
 border-right: 1px solid;
 height: 100%;
 display: inline-grid;
 margin-right: 20px;
 padding: 8px 20px;
 float: left;
}
.dummy-msg-warning- p {
 font-size: 12px;
 color: #e4862c;
}
</style>



// WEBPACK FOOTER //
// src/pages/billing/new/BillingEditPlan.vue